import { axios } from '@/di-container/axios';
import {
  CreateVisitConsultRequestReservationGateway,
  GetVisitConsultItemCodeGateway,
  GetVisitConsultTimeCodeGateway,
  GetVisitConsultUserInfoGateway,
  CancelVisitConsultUsersReservationGateway,
  GetVisitConsultUsersReservationGateway,
  GetVisitConsultChannelInfoGateway,
  GetVisitConsultBasicInfoGateway,
} from '@remodeling/remodeling-manager';

export const visitConsultGateway = () => {
  return {
    request: new CreateVisitConsultRequestReservationGateway(axios),
    getTimeCode: new GetVisitConsultTimeCodeGateway(axios),
    getItemCode: new GetVisitConsultItemCodeGateway(axios),
    getUserInfo: new GetVisitConsultUserInfoGateway(axios),
    getReservationList: new GetVisitConsultUsersReservationGateway(axios),
    getChannel: new GetVisitConsultChannelInfoGateway(axios),
    cancelReservation: new CancelVisitConsultUsersReservationGateway(axios),
    getBasic: new GetVisitConsultBasicInfoGateway(axios),
  };
};
